var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUseless(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.869507,
    y: 0.504883,
    width: 45.6788,
    height: 45.6788,
    rx: 15,
    fill: "#6AB672",
    fillOpacity: 0.17
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2503 19.8966L24.6737 21.5443L23.2953 15.8358L17.7187 17.4835L16.635 12.999C16.0535 13.7312 15.5272 14.5065 15.0607 15.3185C11.2611 21.9738 12.9187 29.392 18.3703 32.575C23.8219 35.7581 31.0031 33.5007 34.8027 26.8454C35.264 26.0321 35.6643 25.1849 36.0001 24.3109L31.6269 25.6039L30.2503 19.8966Z",
    fill: "#6AB672"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseless);
export default __webpack_public_path__ + "static/media/useless.a82828a6.svg";
export { ForwardRef as ReactComponent };